module.exports = __webpack_public_path__ + "img/Hr_Banner.e8ba538b.png";